import { Button, ButtonGroup, Tooltip } from "@material-ui/core";
import { CloudDownload as DownloadIcon } from "@material-ui/icons";
import { get } from "lodash";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { Trans, withTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { compose, lifecycle, withHandlers, withState } from "recompose";
import { saveAs } from "file-saver";
import shpwrite from "@mapbox/shp-write";
import { ApiEndpoint } from "../../env.config";
import { mapLoaded, setSurveyedMapType, getVectorSourceInfo, setPointPopup } from "../../services/actions/GisAction";
import { loading, resetLoading, SetRoadCalculation, SetSurfaceTypeFilter } from "../../services/actions/RoadAction";
import { ShowPermissionRequired } from "../../services/actions/SystemAction";
import {
  LAYER_IDS,
  MAIN_COLOR,
  MAPBOX_ACCESSTOKEN,
  MenuType,
  PermissionType,
  SOURCE_IDS
} from "../../shared/utils/constant";
import { authFileFetch } from "../../shared/utils/fetchUtils";
import {
  getDistanceFromLatLonInKm,
  HasPermissions,
  // zeroPadding,
} from "../../shared/utils/objectExtensions";
import DPYearSlider from "./DPYearSlider";
import SurveyedDetail from "./LeftContent/SurveyedDetail";

import {
  Layer,
  FullscreenControl as MapboxFullscreenControl,
  Map as MapboxMap,
  Marker as MapboxMarker,
  Popup as MapboxPopup,
  NavigationControl,
  Source
} from 'react-map-gl';
import { FilterSurface, FilterSurfaceForce } from "../../services/actions/SurfaceAction";
import { store } from "../..";

const Map = ({
  yearFilter,
  vectorTiles,
  showSurveyedDetail,
  dataDetailSelected,
  closeSurveyedDetail,
  coords,
  showAttributeList,
  rankFilters,
  shouldShowDetail,
  surveyedMapType,
  setMapType,
  downloadShapeFile,
  forceReloadMap,
  setForceReloadMap,
  surfaces,
  surfaceFilters, // アスファルト・コンクリ対応
  currentZoom,
  users,
  userFilter,
  mapEl,
  mapLoaded,
  pointPopup,
  setPointPopup,
  setFilterSurface,
  // selectedDates, // 日付フィルター
}) => {
  const dispatch = useDispatch();
  const userPosition = coords
    ? [get(coords, "latitude"), get(coords, "longitude")]
    : [30.55435, -91.03677];
  const currentUser =
    users?.find((x) => x.id == userFilter) ||
    JSON.parse(sessionStorage.getItem("userLogged"));
  const isOldUser = currentUser?.isOldUser ? true : false;
  const [currentCenterPoint, setCurrentCenterPoint] = React.useState(null);
  const pointClick = useRef({ lat: 0, lng: 0 }); // これいらないかも

  // state変数
  const { isActual, isPredicted } = useSelector((state) => ({
    isActual: state.gis.isActual,
    isPredicted: state.gis.isPredicted
  }));

  // 各種監視変数
  const yearRef = useRef();
  yearRef.current = yearFilter;
  const surveyedMapTypeRef = useRef();
  surveyedMapTypeRef.current = surveyedMapType;
  const vectorTilesRef = useRef();
  vectorTilesRef.current = vectorTiles;

  // 表示中心座標
  const center =
    !isOldUser && currentCenterPoint
      ? currentCenterPoint
      : userPosition
        ? userPosition
        : [0, 0];

  const predictSurfaces = surfaces[0]?.hasPredict
    ? surfaces.map((x) => {
      const newItem = { ...x };
      if (newItem.rangeValue) {
        newItem.rangeValue = JSON.parse(x.rangeValue);
      }
      return newItem;
    })
    : null;

  // MapBox処理開始
  const [isClick, setIsClick] = useState(false);

  // フィルタリング処理
  // - distressAverage(Surface Condition)
  const rankFilterStyle = [];
  rankFilters.map((r, index) => {
    if (r.rangeValue != null) {
      const values = JSON.parse(r.rangeValue);
      const rankFilter = ["all"];
      rankFilter.push(['>=', ['round', ['get', 'distressAverage']], values[0]]);
      rankFilter.push(['<=', ['round', ['get', 'distressAverage']], values[1]]);
      rankFilterStyle.push(rankFilter);
    } else if (r.value != null) {
      rankFilterStyle.push(['==', ['get', 'distressAverage'], r.value])
    }
  });

    const convertHexToRGBA = (hex) => {
      // 空チェック
      if (hex == null || hex == '') {
        return hex;
      }

      // 9文字の長さかどうかを確認
      if (hex.length !== 9) {
        return hex;
      }

      // 先頭の '#' を取り除く
      if (hex.startsWith('#')) {
        hex = hex.slice(1);
      } else {
        return hex;
      }

      // 色部分と透明度部分に分割
      const rHex = hex.slice(0, 2);
      const gHex = hex.slice(2, 4);
      const bHex = hex.slice(4, 6);
      const aHex = hex.slice(6, 8);

      // 16進数から10進数に変換
      const r = parseInt(rHex, 16);
      const g = parseInt(gHex, 16);
      const b = parseInt(bHex, 16);
      const a = parseInt(aHex, 16);

      // 透明度を0から1の範囲に変換
      const alpha = (a / 255).toFixed(2);

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

  // - distressAverageによる地物スタイル(色)の設定
  const yearPaintColorStyle = [];
  if (yearFilter) {
    surfaces.map((s, index) => {
      if (index == 0) yearPaintColorStyle.push('case');
      if (s.rangeValue) {
        // Range value (SPM-PCI/SPM-PCI-DP)
        const values = JSON.parse(s.rangeValue);
        const colorExpressions =
          [
            'all',
            ['>=', ['round', ['get', 'distressAverage']],
              values[0]], ['<=', ['round', ['get', 'distressAverage']],
              values[1]]
          ];
        yearPaintColorStyle.push(colorExpressions);
      } else {
        // Value (SPM-PASER)
        const colorExpressions = ['==', ['get', 'distressAverage'], s.value];
        yearPaintColorStyle.push(colorExpressions);
      }
      const color = convertHexToRGBA(s.color);
      yearPaintColorStyle.push(color);
      if (index == surfaces.length - 1) {
        yearPaintColorStyle.push(MAIN_COLOR);
      }
    });
  }

  // - アスファルト・コンクリフィルタ(Surface Type)
  const surfaceValues = [];
  surfaceFilters.map((s, index) => {
    surfaceValues.push(s.title);
  });

  // - 日付フィルタ(yyyy-MM-ddT00:00:00型式の配列) 未使用
  // const dates = [];
  // selectedDates.map((d, index) => {
  //   // 変更したUIのデータはDate型なので、すべて一度new Dateを実施する
  //   const date = new Date(d);
  //   const dateString = `${date.getFullYear()}-${zeroPadding(date.getMonth() + 1, 2)}-${zeroPadding(date.getDate(), 2)}T00:00:00`;
  //   dates.push(dateString);
  // });

  // クリック処理(LINE)
  let hoveredStateLineId = null;
  const handleClickLine = (e) => {
    pointClick.current = e.lngLat;

    // NOTE 同じ緯度経度にタイムスライダの複数年の線があるため、タイムスライダの選択状態で絞り込む
    const targetFeature = e.features.filter((feature) => feature.properties.year === yearRef.current)[0];
    if (targetFeature == null) return;

    setPointPopup([0, 0]);

    // ベクタタイルはライン生成時に頂点を消している可能性があるため、クリック点を渡す
    const pos = e.lngLat.toArray().toReversed();

    const kp = targetFeature.properties._id;
    const surveyedDate = targetFeature.properties.surveyedDate;

    showSurveyedDetail(pos, surveyedDate, kp, { point: { lat: pointClick.current.lat, lng: pointClick.current.lng } });
    setIsClick(true);
  }

  // ホバー処理(LINE)
  const handleMouseMoveLine = (e) => {
    mapEl.current.getCanvas().style.cursor = 'default';
    if (!vectorTilesRef.current) return;
    if (e.features.length === 0) return;
    if (hoveredStateLineId !== null) {
      mapEl.current.removeFeatureState({
        source: SOURCE_IDS.LINE,
        sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "line").name,
        id: hoveredStateLineId
      });
      hoveredStateLineId = null;
    }
    // NOTE 同じ緯度経度にタイムスライダの複数年の線があるため、タイムスライダの選択状態で絞り込む
    const targetFeature = e.features.filter((feature) => feature.properties.year === yearRef.current)[0];
    if (!targetFeature) return;

    hoveredStateLineId = targetFeature.properties._id;
    mapEl.current.setFeatureState({
      source: SOURCE_IDS.LINE,
      sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "line").name,
      id: hoveredStateLineId
    }, {
      hover: true
    });
  }

  // リーブ処理(LINE)
  const handleMouseLeaveLine = () => {
    mapEl.current.getCanvas().style.cursor = '';
    if (hoveredStateLineId !== null && vectorTilesRef.current != null) {
      mapEl.current.removeFeatureState({
        source: SOURCE_IDS.LINE,
        sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "line").name,
        id: hoveredStateLineId
      });
    }
    hoveredStateLineId = null;
  }

  // クリック処理(POINT)
  const handleClickPoint = (e) => {
    if (!mapEl.current || !vectorTilesRef.current) return;

    pointClick.current = e.lngLat.toArray();

    setPointPopup([0, 0]);
    const targetFeature = e.features.filter((feature) => feature.properties.year === yearRef.current)[0];
    const point = targetFeature.geometry.coordinates.toReversed();

    const kp = targetFeature.properties._id;
    const surveyedDate = targetFeature.properties.surveyedDate;
    showSurveyedDetail(point, surveyedDate, kp, null);
    setIsClick(true);
  }

  // ホバー処理(POINT)
  let hoveredStatePointId = null;
  const handleMouseMovePoint = (e) => {
    mapEl.current.getCanvas().style.cursor = 'default';
    if (!vectorTilesRef.current) return;
    if (e.features.length === 0) return;

    if (hoveredStatePointId !== null) {
      mapEl.current.removeFeatureState({
        source: SOURCE_IDS.POINT,
        sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "point").name,
        id: hoveredStatePointId
      });
      hoveredStatePointId = null;
    }
    // NOTE: 同じ緯度経度にタイムスライダの複数年の線があるため、タイムスライダの選択状態で絞り込む
    const targetFeature = e.features.filter((feature) => feature.properties.year === yearRef.current)[0];
    if (!targetFeature) return;
    hoveredStatePointId = targetFeature.properties._id;
    mapEl.current.setFeatureState({
      source: SOURCE_IDS.POINT,
      sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "point").name,
      id: hoveredStatePointId
    }, {
      hover: true
    });
  }
  // リーブ処理(POINT)
  const handleMouseLeavePoint = () => {
    mapEl.current.getCanvas().style.cursor = '';
    if (hoveredStatePointId !== null && vectorTilesRef.current != null) {
      mapEl.current.removeFeatureState({
        source: SOURCE_IDS.POINT,
        sourceLayer: getVectorSourceInfo(vectorTilesRef.current, "point").name,
        id: hoveredStatePointId
      });
    }
    hoveredStatePointId = null;
  }

  // const handleMoveEnd = () => {
  //   const state = store.getState();
  //   const surfacesForCalc = [...state.surface.surfaces].map((x) => {
  //     let rangeValue = [-1, -1];
  //     if (x.rangeValue) {
  //       rangeValue = JSON.parse(x.rangeValue);
  //     }
  //     return {
  //       title: x.title,
  //       low: rangeValue[0],
  //       high: rangeValue[1],
  //       count: 0,
  //     };
  //   });
  //   setTimeout(() => {
  //     try {
  //       for (const key in surfacesForCalc) {
  //         surfacesForCalc[key].count = 0;
  //       }
  //       const newSurfaceTypeFilter = [...state.road.surfaceTypeFilter];
  //       const filter = mapEl.current.getFilter(state.gis.surveyedMapType);
  //       if (!filter) return;
  //       const features = mapEl.current.queryRenderedFeatures({
  //         layers: [state.gis.surveyedMapType],
  //         filter: filter ? filter : [],
  //       });
  //       const featuresForSource = mapEl.current.querySourceFeatures(
  //         state.gis.surveyedMapType,
  //         {
  //           sourceLayer: getVectorSourceInfo(
  //             vectorTilesRef.current,
  //             state.gis.surveyedMapType
  //           ).name,
  //           filter: filter && filter.length > 1 ? filter.slice(0, 2) : [],
  //         }
  //       );
  //       const uniqueFeatures = {};
  //       for (const key in features) {
  //         const id = features[key].id;
  //         if (!uniqueFeatures[id]) {
  //           uniqueFeatures[id] = features[key].properties;
  //         }
  //       }
  //       for (const key in featuresForSource) {
  //         const { surface } = featuresForSource[key].properties;
  //         const type = newSurfaceTypeFilter.find(
  //           (type) => type && type.title == surface
  //         );
  //         if (!type && surface != null && surface != "") {
  //           newSurfaceTypeFilter.push({ title: surface });
  //         }
  //       }
  //       let sum = 0;
  //       let count = 0;
  //       for (const key in uniqueFeatures) {
  //         const { distressAverage } = uniqueFeatures[key];
  //         sum += distressAverage;
  //         count++;
  //         for (const key in surfacesForCalc) {
  //           if (
  //             surfacesForCalc[key].low <= distressAverage &&
  //             surfacesForCalc[key].high + 1 > distressAverage
  //           ) {
  //             surfacesForCalc[key].count++;
  //             break;
  //           }
  //         }
  //       }
  //       const distressAverage = count ? Number((sum / count).toFixed(2)) : 0;
  //       dispatch(
  //         SetRoadCalculation({
  //           distressAverage: distressAverage,
  //           surfacesForCalc: surfacesForCalc,
  //         })
  //       );
  //       if (newSurfaceTypeFilter.length > 0) {
  //         dispatch(SetSurfaceTypeFilter([...newSurfaceTypeFilter]));
  //       }
  //     } catch (e) {
  //       console.error(e);
  //     }
  //   }, 500);
  // };

  // ロード時:初期位置への移動
  const handleLoad = () => {
    mapLoaded(true);
    mapEl.current.on('click', LAYER_IDS.LINE, handleClickLine);
    mapEl.current.on('mousemove', LAYER_IDS.LINE, handleMouseMoveLine);
    mapEl.current.on('mouseleave', LAYER_IDS.LINE, handleMouseLeaveLine);
    mapEl.current.on('click', LAYER_IDS.POINT, handleClickPoint);
    mapEl.current.on('mousemove', LAYER_IDS.POINT, handleMouseMovePoint);
    mapEl.current.on('mouseleave', LAYER_IDS.POINT, handleMouseLeavePoint);
    // mapEl.current.on('moveend', LAYER_IDS.POINT, handleMoveEnd);
    // mapEl.current.on('moveend', LAYER_IDS.LINE, handleMoveEnd);
  }

  /**
   * Sourceから取得できるboundsを基準にしたフォーカス処理
   * SourceはTileset情報を元にしており、これが地物に対し思ったようなboundsになっていないことがある。
   * これに関してはMapbox API由来になるため、現状こちらではコントロール不可
   * @returns
   */
  const setFocus = () => {
    if (mapEl.current == null) return false;
    const source = mapEl.current.getSource(surveyedMapType === "line" ? SOURCE_IDS.LINE : SOURCE_IDS.POINT);
    if (source && source.bounds != null) {
      // console.log(`取得Bounds:[${source.bounds}]→フォーカス実施`);
      const pCenter = [(source.bounds[0] + source.bounds[2]) / 2, (source.bounds[1] + source.bounds[3]) / 2]
      mapEl.current.setCenter(pCenter);
      return true;
    } else {
      return false;
    }
  }

  /**
   * setFocus処理のポーリング付き処理(繰り返し上限あり)
   * @param {*} duration ポーリング感覚(ms)
   * @param {*} loopMax 繰り返し上限(回)
   */
  const setFocusWithInterval = (duration = 1000, loopMax = 120) => {
    let count = 0;
    const timeID = setInterval(() => {
      // 現在のソースから中心位置を取得
      if (setFocus() === true) {
        clearInterval(timeID);
      }
      count++;
      if (count > loopMax) {
        console.log(`フォーカス処理:指定回数${loopMax}を超えたので中止`);
        clearInterval(timeID);
      }
    }, duration);
  }

  const [sourceLayerPoint, setSourceLayerPoint] = useState("");
  const [sourceUrlPoint, setSourceUrlPoint] = useState("");
  const [sourceLayerLine, setSourceLayerLine] = useState("");
  const [sourceUrlLine, setSourceUrlLine] = useState("");
  useEffect(() => {
    // console.log(`ユーザ更新(Map.js) -> ${userFilter}`);
    if (mapEl.current == null) return;
    if (userFilter == null) return;
    if (vectorTiles == null) return;

    // line選択時、Surface Typeフィルタのリセット
    if (surveyedMapType === "line") {
      setFilterSurface(null);
    }

    const pointInfo = getVectorSourceInfo(vectorTiles, "point");
    const lineInfo = getVectorSourceInfo(vectorTiles, "line");
    if (surveyedMapType === "point") {
      if (mapEl.current.getLayer(LAYER_IDS.POINT)?.sourceLayer !== pointInfo.name) {
        // console.log(`[${LAYER_IDS.POINT}]レイヤ切り替わりを観測`);
        if (mapEl.current.getMap().getLayer(LAYER_IDS.POINT)) {
          mapEl.current.getMap().removeLayer(LAYER_IDS.POINT);
          mapEl.current.getMap().removeSource(SOURCE_IDS.POINT);
        }
        setSourceLayerPoint(pointInfo.name);
        setSourceUrlPoint("mapbox://" + pointInfo.id);
        setSourceLayerLine(lineInfo.name);
        setSourceUrlLine("mapbox://" + lineInfo.id);
        setFocusWithInterval();
      }
    } else if (surveyedMapType === "line") {
      if (mapEl.current.getLayer(LAYER_IDS.LINE)?.sourceLayer !== lineInfo.name) {
        // console.log(`[${LAYER_IDS.LINE}]レイヤ切り替わりを観測`);
        if (mapEl.current.getMap().getLayer(LAYER_IDS.LINE)) {
          mapEl.current.getMap().removeLayer(LAYER_IDS.LINE);
          mapEl.current.getMap().removeSource(SOURCE_IDS.LINE);
        }
        setSourceLayerPoint(pointInfo.name);
        setSourceUrlPoint("mapbox://" + pointInfo.id);
        setSourceLayerLine(lineInfo.name);
        setSourceUrlLine("mapbox://" + lineInfo.id);
        setFocusWithInterval();
      }
    }
  }, [userFilter, vectorTiles, surveyedMapType]);

  useEffect(() => {
    if(!mapEl.current) return;
    // mapEl.current.once('styledata',handleMoveEnd)
  }, [yearFilter, isActual, isPredicted,surfaces]);

  // filter条件を網羅した状態を作成する
  const filterAll = ['all'];
  // yearFilter(必須)
  filterAll.push(['==', ['get', 'year'], yearFilter]);

  // distressFilter(任意)
  if (rankFilterStyle.length > 0) {
    const tmpFilter = ["any"];
    for (const rankFilter of rankFilterStyle) {
      tmpFilter.push(rankFilter);
    }
    filterAll.push(tmpFilter);
  }

  // surfaceFilter(任意)
  if (surfaceValues.length > 0) {
    filterAll.push(["in", ["get", "surface"], ["literal", surfaceValues]]);
  }

  // dateFilter(任意)
  // if (dates.length > 0) {
  //   filterAll.push(["in", ["get", "surveyedDate"], ["literal", dates]]);
  // }

  // dataType(Actual/Predicted)
  if (isPredicted && !isActual) {
    filterAll.push(["==", ["get", "isP"], true]);
  } else if (!isPredicted && isActual) {
    filterAll.push(["==", ["get", "isP"], false]);
  } else if (!isPredicted && !isActual) {
    filterAll.push(["==", ["get", "isP"], 99]);
  }

  return (
    <>
      {/* 地図全体 */}
      {(
        <MapboxMap
          ref={mapEl}
          mapboxAccessToken={MAPBOX_ACCESSTOKEN}
          maxZoom={17}
          minZoom={1}
          dragRotate={false}
          touchZoomRotate={false}
          logoPosition="bottom-right"
          // NOTE 初期位置は別途指定
          initialViewState={{
            longitude: center[1],
            latitude: center[0],
            zoom: currentZoom
          }}
          style={{
            height: `calc(100vh - ${showAttributeList
              ? window.innerHeight < 700
                ? "264px"
                : "364px"
              : "64px"
              })`,
          }}
          mapStyle="mapbox://styles/mapbox/light-v11"
          onLoad={handleLoad}
          onDragEnd={() => {
            // ポップアップ表示時にD&Dで自動で閉じるかどうかの判定
            const centerPoint = mapEl?.current?.getCenter();
            if (JSON.stringify(pointPopup) != JSON.stringify([0, 0]) && shouldShowDetail) {
              const distanceFromCenter = getDistanceFromLatLonInKm(
                centerPoint.lat,
                centerPoint.lng,
                pointPopup[0],
                pointPopup[1]
              );
              // console.log(`移動距離:${distanceFromCenter}`);
              if (distanceFromCenter > 5) {
                setIsClick(false)
                closeSurveyedDetail();
                // alert("The detail marker is closed because it's out of the map.")
              }
            }
            if (centerPoint) {
              setCurrentCenterPoint([centerPoint.lat, centerPoint.lng]);
            }
            setForceReloadMap(true);
          }}>
          {/* 拡大縮小ボタン */}
          <NavigationControl showCompass={false} />
          {/* 最大化 */}
          <MapboxFullscreenControl />
          {/* yearスライダー */}
          <DPYearSlider closeSurveyedDetail={closeSurveyedDetail} />
          {/* LINE|POINT */}
          <ButtonGroup size="small" className="map-panel-type" style={{ position: 'absolute', top: '120px', right: '10px' }}>
            <Button
              className={`${surveyedMapType === "point" ? "type-selected" : ""}`}
              onClick={() => setMapType("point")}>
              Point
            </Button>
            <Button
              className={`${surveyedMapType === "line" ? "type-selected" : ""}`}
              onClick={() => setMapType("line")}>
              Line
            </Button>
          </ButtonGroup>
          {/* Shapeダウンロード */}
          {vectorTiles && (
            <ButtonGroup size="small" style={{ position: 'absolute', top: '160px', right: '10px' }}>
              <Button
                variant="outlined"
                size="small"
                className="btn-download-shape-file"
                onClick={downloadShapeFile}>
                <Tooltip title={<Trans>download_shapefile</Trans>} aria-label="add">
                  <DownloadIcon />
                </Tooltip>
              </Button>
            </ButtonGroup>
          )}
          {/* ベクタータイル利用時のレイヤー */}
          {/* Line */}
          {surveyedMapType === "line" && vectorTiles && (
            <>
              <Source id={SOURCE_IDS.LINE} type="vector" url={sourceUrlLine} promoteId="_id">
                <Layer
                  id={LAYER_IDS.LINE}
                  source-layer={sourceLayerLine}
                  filter={filterAll}
                  type='line'
                  paint={{
                    'line-width': [
                      'case',
                      ['boolean', ['feature-state', 'hover'], false], // hoverの値取得、デフォルト値false、の意
                      6,  // hover時
                      3,  // 通常時
                    ],
                    'line-color': yearPaintColorStyle,
                  }}
                />
                {/* ラベル */}
                <Layer
                  id={LAYER_IDS.LINE_LABEL}
                  source-layer={sourceLayerLine}
                  filter={filterAll}
                  type="symbol"
                  paint={{
                    "text-color": "#000000",
                    "text-halo-color": "#ffffff",
                    "text-halo-width": 1.5
                  }}
                  layout={{
                    "text-size": 12,
                    "text-field": ["get", "distressAverage"],
                    "text-rotation-alignment": "viewport", // これを入れないとラインの角度にラベルが依存する形になる
                    "symbol-placement": "line-center",
                    "text-translate": [0, 1]
                  }}
                />
              </Source>
            </>
          )}
          {/* Point */}
          {surveyedMapType === "point" && vectorTiles && (
            <>
              <Source id={SOURCE_IDS.POINT} type="vector" url={sourceUrlPoint} promoteId="_id">
                <Layer
                  id={LAYER_IDS.POINT}
                  source-layer={sourceLayerPoint}
                  filter={filterAll}
                  type="circle"
                  paint={{
                    'circle-radius': [
                      'case',
                      ['boolean', ['feature-state', 'hover'], false], // hoverの値取得、デフォルト値false、の意
                      8,  // hover時
                      5   // 通常時
                    ],
                    'circle-color': yearPaintColorStyle,
                  }}
                />
              </Source>
            </>
          )}
          {isClick && shouldShowDetail && dataDetailSelected && (
            <MapboxMarker
              longitude={pointPopup ? pointPopup[1] : -96.64943}
              latitude={pointPopup ? pointPopup[0] : 32.882874}
              className="popup-road-detail">
              {/* ポップアップ */}
              <MapboxPopup
                longitude={pointPopup ? pointPopup[1] : -96.64943}
                latitude={pointPopup ? pointPopup[0] : 32.882874}
                onClose={() => {
                  setIsClick(false);
                  closeSurveyedDetail();
                }}
                className={`popup-road-detail ${surveyedMapType === "line" ? "" : "popup-content-point"}`}
                maxWidth="600px">
                {/* ポップアップ詳細情報 */}
                <SurveyedDetail
                  {...dataDetailSelected}
                  // surveyedDataの中身を確認し、ベクタータイルのプロパティから生成する
                  showSurveyedDetail={showSurveyedDetail}
                  surveyedData={[]}
                  closeSurveyedDetail={closeSurveyedDetail}
                  setIsClick={setIsClick} />
              </MapboxPopup>
            </MapboxMarker>
          )}
        </MapboxMap>
      )}
    </>
  );
};
export default compose(
  withTranslation("translations"),
  withState("forceReloadMap", "setForceReloadMap", false),
  withState("currentZoom", "setCurrentZoom", 15),
  connect(
    (state) => ({
      vectorTiles: state.road.vectorTiles,
      showAttributeList: state.road.showAttributeList,
      rankFilters: state.road.rankFilters,
      surveyedMapType: state.gis.surveyedMapType,
      loading: state.gis.loading,
      surfaces: state.surface.surfaces,
      userFilter: state.road.userFilter,
      loggedUser: state.auth.user,
      users: state.user.users,
      yearFilter: state.road.yearFilter,
      showSideContent: state.gis.showSideContent,
      surfaceFilters: state.surface.surfaceFilters, // アスファルト・コンクリ対応
      mapLoaded: state.gis.mapLoaded,
      pointPopup: state.gis.pointPopup, // ポップアップ基点座標
      // selectedDates: state.road.selectedDates, // 日付フィルタ
    }),
    (dispatch) => ({
      setMapType: (value) => dispatch(setSurveyedMapType(value)),
      showPermissionRequired: () => dispatch(ShowPermissionRequired()),
      showLoading: () => dispatch(loading()),
      hideLoading: () => dispatch(resetLoading()),
      mapLoaded: (value) => dispatch(mapLoaded(value)),
      setPointPopup: (value) => dispatch(setPointPopup(value)),
      setFilterSurface: (surface) => dispatch(FilterSurface(surface)),
    })
  ),
  withHandlers({
    downloadShapeFile:
      ({
        surveyedMapType,
        rankFilters,
        showPermissionRequired,
        surfaces,
        userFilter,
        loggedUser,
        showLoading,
        hideLoading,
        yearFilter,
      }) =>
        async () => {
          if (!HasPermissions(MenuType.GIS, PermissionType.Download)) {
            return showPermissionRequired();
          }
          showLoading();
          try {
            const yearParam = yearFilter ? `year=${yearFilter}` : "";
            const userId = userFilter;
            const features = await (await authFileFetch(
              `${ApiEndpoint}/Road/surveyed/${userId}/type/${surveyedMapType}?${yearParam}`,
              { method: "GET" }
            )).json();
            const fileName = `pms_shapefile_${surveyedMapType === "line" ? "line_" : "point_"}${moment().format("DDMMYYYYhhmmss")}`;
            const options = {
              file: fileName,
              folder: fileName,
              outputType: "blob",
              types: {
                point: "points",
                polygon: "polygons",
                polyline: "polylines",
              },
            };
            shpwrite.zip({
              type: "FeatureCollection",
              features: features,
            }, options)
            .then((blob) => {
              saveAs(blob, options.file + '.zip');
              hideLoading();
            });
          } catch (error) {
            console.error(error);
            hideLoading();
          }
        },
  }),
  lifecycle({
    componentWillUpdate(nextProps) {
      try {
        if (JSON.stringify(this.props.surveyedAllocated) !== JSON.stringify(nextProps.surveyedAllocated)) {
          this.props.setForceReloadMap(true);
        }
      } catch (_err) {
        //ignored
      }
    },
    componentDidUpdate(prevProps) {
      if (this.props.forceReloadMap) {
        this.props.setForceReloadMap(false);
      }
      try {
        if ((!this.props.showSideContent && prevProps.showSideContent) ||
          JSON.stringify(prevProps.rankFilters) !== JSON.stringify(this.props.rankFilters)) {
          setTimeout(() => {
            this.props.setForceReloadMap(true);
          }, 500);
        }
      } catch (_err) {
        //ignored
      }
    },
    componentWillUnmount() {
      this.props.mapLoaded(false);
    }
  })
)(Map);
